function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.42 44.58V26.05a3.42 3.42 0 012.74-3.35V18.58a6.86 6.86 0 01-5.22-6.66V2.6a1.69 1.69 0 013.38 0v9.33c0 1.33.74 2.5 1.84 3.08V2.59a1.69 1.69 0 013.38 0v12.34a3.48 3.48 0 001.73-3v-.02V2.6a1.69 1.69 0 013.38 0v9.33a6.86 6.86 0 01-5.11 6.63V22.7a3.42 3.42 0 012.74 3.35v18.53A3.42 3.42 0 0116.87 48h-2.04a3.42 3.42 0 01-3.41-3.42zm18.78 0V26.05c0-1.43.88-2.66 2.13-3.16a5.91 5.91 0 01-2.88-5.29l-.08-13.02A4.68 4.68 0 0134.13 0a4.67 4.67 0 014.76 4.58v20.39c.1.35.17.7.17 1.08v18.53A3.42 3.42 0 0135.64 48h-2.03a3.42 3.42 0 01-3.42-3.42zm5.31-23.87V4.58c0-.59-.52-1.2-1.38-1.2-.82 0-1.38.6-1.38 1.2l.08 13c0 .96.28 1.55.75 2 .4.4 1 .78 1.93 1.13z"
})));